import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress } from '@mui/material';
import '@/styles/components/Loader.css';
const Loader = ({ loading }) => !loading ? null : (_jsx("div", { className: "loader", "data-testid": "loader", children: _jsx(CircularProgress, {}) }));
export default Loader;
